interface IProps {
  color: string;
}

export const BellIcon = ({ color }: IProps) => {
  return (
    <div>
      <svg
        width="23"
        height="26"
        viewBox="0 0 23 26"
        fill={color}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M1.82902 20.4248H21.0281C22.1787 20.4248 22.8571 19.8378 22.8571 18.9753C22.8571 17.7773 21.6337 16.6992 20.5799 15.633C19.7804 14.8065 19.5624 13.1054 19.4776 11.7278C19.3807 7.12771 16.5863 2.62374 12.9686 2.38522C12.9686 2.38522 12.9687 1.43113 12.7274 0.715567C12.4862 0 11.5215 0 11.5215 0C11.5215 0 10.5568 0 10.3156 0.715567C10.0744 1.43113 10.0745 2.38522 10.0745 2.38522C5.73321 2.86227 3.47638 7.12771 3.39162 11.7278C3.29472 13.1054 3.08877 14.8065 2.27721 15.633C1.23551 16.6992 0 17.7773 0 18.9753C0 19.8378 0.690418 20.4248 1.82902 20.4248ZM7.74014 22.054C7.88552 23.803 9.37541 25.2644 11.4346 25.2644C13.4817 25.2644 14.9716 23.803 15.129 22.054H7.74014Z" />
      </svg>
    </div>
  );
};
